<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
      </v-toolbar>
      <v-card-text style="padding: 10px">
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  label="Prefeitura:"
                  :rules="fieldRules"
                  :items="prefectures"
                  item-value="prefecture_id"
                  item-text="prefecture_social_name"
                  v-model="data.prefecture_id"
                  @change="getVehicles(data.prefecture_id)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  label="Veículo:"
                  :rules="fieldRules"
                  :items="vehicles"
                  item-value="vehicle_id"
                  item-text="vehicle_board"
                  v-model="data.vehicle_id"
                >
                  <template slot="selection" slot-scope="{ item }">
                    {{ item.brand_desc }} - {{ item.model_desc }} -
                    {{
                      item.vehicle_categoria == 1
                        ? item.vehicle_board
                        : item.vehicle_cod_maquina
                    }}
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    {{ item.brand_desc }} - {{ item.model_desc }} -
                    {{
                      item.vehicle_categoria == 1
                        ? item.vehicle_board
                        : item.vehicle_cod_maquina
                    }}
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <Date
                  @dateValue="[(data.data = $event)]"
                  label="Data"
                  :rules="fieldRules"
                />
              </v-col>
              <v-col cols="12" sm="9">
                <v-select
                  label="Tipo da Situação da Frota ou Máquina:"
                  :items="[
                    { text: 'Em Uso', value: 1 },
                    { text: 'Em Manutenção', value: 2 },
                    { text: 'Baixada', value: 3 },
                  ]"
                  item-value="value"
                  item-text="text"
                  v-model="data.situacao"
                  :rules="fieldRules"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-footer style="padding: 10px">
        <v-spacer />
        <v-btn
          depressed
          large
          color="primary"
          class="mr-4"
          :loading="loader"
          @click="validate"
        >
          Salvar
        </v-btn>
      </v-footer>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Date from "@/components/InputDate.vue";
export default {
  components: { Date },
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    prefectures: [],
    vehicles: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      vehicle_id: null,
      prefecture_id: null,
      situacao: null,
      data: null,
    },
  }),
  created() {
    this.$http.get("prefectures").then((r) => (this.prefectures = r.data));
  },
  methods: {
    getVehicles(prefecture_id) {
      this.$http.get(`/vehicles/prefectures/${prefecture_id}`).then((r) => {
        this.vehicles = r.data;
      });
    },
    validate() {
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .post("/vehicles/situacao", this.data)
        .then(() => {
          this.snack.show = true;
          this.snack.message = "Criado com sucesso!";
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
          setTimeout(() => {
            this.$router.push("/vehicles-manager/situacao");
          }, 1500);
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
